import _defineProperty from "/var/www/vhosts/thuisinaanbouw.nl/gatsby/thuisinaanbouw.nl/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { CLASS_FLEX_CENTER, CLASS_FULLSIZE, clsx, createIcon, cssClass, cssVar, ELEMENT_ICON, ImageSlide, isImageSlide, makeComposePrefix } from "../../core/index.js";
import { cssPrefix, cssThumbnailPrefix } from "./utils.js";
var VideoThumbnailIcon = createIcon("VideoThumbnail", React.createElement("path", {
  d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}));
var UnknownThumbnailIcon = createIcon("UnknownThumbnail", React.createElement("path", {
  d: "M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"
}));

var renderThumbnail = function renderThumbnail(_ref) {
  var slide = _ref.slide,
      render = _ref.render,
      rect = _ref.rect,
      imageFit = _ref.imageFit;

  var _a;

  var customThumbnail = (_a = render.thumbnail) === null || _a === void 0 ? void 0 : _a.call(render, {
    slide: slide,
    render: render,
    rect: rect,
    imageFit: imageFit
  });

  if (customThumbnail) {
    return customThumbnail;
  }

  var thumbnailIconClass = cssClass(cssThumbnailPrefix(ELEMENT_ICON));

  if (!isImageSlide(slide)) {
    if (slide.type === "video") {
      return React.createElement(React.Fragment, null, "poster" in slide && React.createElement("img", {
        alt: "",
        src: slide.poster,
        className: clsx(cssClass(CLASS_FULLSIZE), cssClass(cssPrefix("contain_image")))
      }), React.createElement(VideoThumbnailIcon, {
        className: thumbnailIconClass
      }));
    }
  } else {
    return React.createElement(ImageSlide, {
      slide: slide,
      render: render,
      rect: rect,
      imageFit: imageFit
    });
  }

  return React.createElement(UnknownThumbnailIcon, {
    className: thumbnailIconClass
  });
};

var activePrefix = makeComposePrefix("active");
var fadeInPrefix = makeComposePrefix("fadein");
var fadeOutPrefix = makeComposePrefix("fadeout");
var placeholderPrefix = makeComposePrefix("placeholder");
var DELAY = "delay";
var DURATION = "duration";
export var Thumbnail = function Thumbnail(_ref2) {
  var _ref3, _ref4;

  var rect = _ref2.rect,
      slide = _ref2.slide,
      onClick = _ref2.onClick,
      active = _ref2.active,
      fadeIn = _ref2.fadeIn,
      fadeOut = _ref2.fadeOut,
      placeholder = _ref2.placeholder,
      render = _ref2.render,
      imageFit = _ref2.imageFit,
      style = _ref2.style;
  return React.createElement("button", {
    type: "button",
    className: clsx(cssClass(CLASS_FLEX_CENTER), cssClass(cssThumbnailPrefix()), active && cssClass(cssThumbnailPrefix(activePrefix())), fadeIn && cssClass(cssThumbnailPrefix(fadeInPrefix())), fadeOut && cssClass(cssThumbnailPrefix(fadeOutPrefix())), placeholder && cssClass(cssThumbnailPrefix(placeholderPrefix()))),
    style: _objectSpread(_objectSpread(_objectSpread({}, fadeIn ? (_ref3 = {}, _defineProperty(_ref3, cssVar(cssThumbnailPrefix(fadeInPrefix(DURATION))), "".concat(fadeIn.duration, "ms")), _defineProperty(_ref3, cssVar(cssThumbnailPrefix(fadeInPrefix(DELAY))), "".concat(fadeIn.delay, "ms")), _ref3) : null), fadeOut ? (_ref4 = {}, _defineProperty(_ref4, cssVar(cssThumbnailPrefix(fadeOutPrefix(DURATION))), "".concat(fadeOut.duration, "ms")), _defineProperty(_ref4, cssVar(cssThumbnailPrefix(fadeOutPrefix(DELAY))), "".concat(fadeOut.delay, "ms")), _ref4) : null), style),
    onClick: onClick
  }, slide && renderThumbnail({
    slide: slide,
    render: render,
    rect: rect,
    imageFit: imageFit
  }));
};